<template>
  <div
    v-if="
      (param === 'layout.aspectRatio' && optionEnabled === true) || param !== 'layout.aspectRatio'
    "
    class="control aspectratio"
  >
    <div class="control__title">
      <div class="title">
        <div class="title-text">
          {{ title }}
        </div>
        <div class="control__helper">
          <div class="control__trigger" @mouseover="showHint = true" @mouseleave="showHint = false">
            <img src="https://sirv.sirv.com/website/theme2/icon/question.svg" :alt="hint" />
          </div>
          <div v-show="showHint" class="hint">
            {{ hint }}
          </div>
        </div>
      </div>
    </div>
    <div class="control__action">
      <div class="control__choice">
        <div
          v-show="!selectStatus"
          class="fakeoverlay"
          :class="{ disabled: !selectStatus }"
          @click="selectStatus = !selectStatus"
        />
        <el-input-number
          v-model.number="value"
          controls-position="right"
          :min="min"
          :max="max"
          type="number"
          :step="step"
          :disabled="!selectStatus"
          @change="changeOption"
        />
        <span class="separator">:</span>
        <el-input-number
          ref="input2"
          v-model.number="value2"
          controls-position="right"
          :min="min"
          :max="max"
          type="number"
          :step="step"
          :disabled="!selectStatus"
          @change="changeOption"
        />
      </div>
      <el-checkbox v-model="selectStatus" class="control__checkbox" @change="changeOption" />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import optionEnabled from "@/store/observable/option-enabled";

export default {
  name: "NumberInputCustomDouble",
  props: {
    title: {
      type: String,
      default: "",
    },
    default: {
      type: [Number, String],
      default: 0,
    },
    hint: {
      type: String,
      default: "",
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 0,
    },
    step: {
      type: Number,
      default: 0,
    },
    status: {
      type: Boolean,
    },
    parameter: {
      type: String,
      default: "",
    },
    eventClick: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    let value = typeof this.default !== "string" ? this.default : this.default.split(":")[0];
    let value2 = typeof this.default !== "string" ? this.default : this.default.split(":")[1];
    return {
      value,
      value2,
      valueSelect: "px",
      selectStatus: this.status,
      showHint: false,
      param: this.parameter,
      selectOption: [{ value: "px" }, { value: "%" }],
    };
  },
  emits: ["changeOption"],
  computed: {
    optionEnabled,

    ...mapState(["clearOptions", "settings"]),
  },
  watch: {
    clearOptions(value) {
      if (value) {
        this.selectStatus = false;
        this.value = typeof this.default !== "string" ? this.default : this.default.split(":")[0];
        this.value2 = typeof this.default !== "string" ? this.default : this.default.split(":")[1];
      }
    },
    eventClick(val) {
      this.selectStatus = val;
      this.value = typeof this.default !== "string" ? this.default : this.default.split(":")[0];
      this.value2 = typeof this.default !== "string" ? this.default : this.default.split(":")[1];
    },
    selectStatus(val) {
      if (val === true) {
        this.changeOption();
      }
    },
  },
  mounted() {
    // console.log(this.optionEnabled);
    if ("input" in this.$refs) {
      this.$refs.input.$el.querySelector("input").type = "number";
    }

    if ("input2" in this.$refs) {
      this.$refs.input2.$el.querySelector("input").type = "number";
    }
  },
  methods: {
    changeOption() {
      let value =
        this.selectStatus === true
          ? `${this.value || this.default}:${this.value2 || this.default}`
          : "";

      this.$emit("changeOption", {
        parameter: `${this.parameter}`,
        separator: ":",
        value: value,
      });
    },
  },
};
</script>
<style lang="scss">
.aspectratio {
  // display: none !important;
  .el-input-number.is-controls-right {
    max-width: 100%;
    width: 100%;
    .el-input__inner {
      text-align: left !important;
    }
  }
  .el-input-number__decrease,
  .el-input-number__increase {
    width: 25px !important;
  }

  .title-text--sub {
    margin-top: 10px;
  }

  /* Chrome, Safari, Edge, Opera */

  .separator {
    margin: 0 10px;
    font-size: 22px;
    color: #bbb;
  }

  ::v-deep {
    & input::-webkit-outer-spin-button,
    & input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* Firefox */
    & input[type="number"] {
      -moz-appearance: textfield;
    }
  }

  .control__choice {
    display: flex;
  }

  .control__select {
    width: 100px;
  }
}
</style>
